import React, { Fragment } from 'react'
import { Loading, Pill } from '@myxplor/ui'

import { recordActionsToDisplay } from '../../../../ui/gov-actions'
import RecordDisplayList from '../../../../ui/record-display-list'
import { MyChildStatus } from './mychild-status'

import Empty from './empty'
import updateMyChild from '../actions/update-myChild'
import checkDeviceCredentials from '../actions/check-device-credentials'
import { EventDisplay } from '../../events-management'


const serviceStartDate = ({ CCSApproval }) => {
  try {
    return CCSApproval.results.filter(record => String(record.status).toLowerCase() === 'curr')[0]
      .startDate
  } catch (error) {
    return null
  }
}

const serviceAddress = ({ Address }) =>
  [
    Address.results[0].streetLine1,
    Address.results[0].suburb,
    Address.results[0].postcode,
    Address.results[0].state,
  ]
    .filter(val => val)
    .join('\u000A')

const level1 = [
  {
    key: 'ServiceName.results.0.name',
    label: 'Name',
  },
  {
    key: 'serviceID',
    label: 'Service ID',
  },
  {
    key: 'serviceType',
    label: 'Service Type',
  },
  {
    label: 'Start Date',
    fn: serviceStartDate,
  },
  {
    label: 'Address',
    fn: serviceAddress,
  },
]

const level2 = [
  {
    key: 'ACECQAExemptionReason',
    label: 'ACECQA Exemption Reason',
  },
]

const actionsForRecord = ({ record }) => [
  updateMyChild({ record }),
  checkDeviceCredentials({ record })
]

const RegoBadges = ({ record }) => (
  <Fragment>
    <ul>
      <li>
        <Pill>{record.status}</Pill>
      </li>
      {
        record.has_active_events && (
          <li>
            <Pill>EVENT</Pill>
          </li>
        )
      }
      <li>
        <MyChildStatus status={record.my_child_submission_status} />
      </li>
    </ul>
    <div style={{display: 'block'}}>
      <EventDisplay events={record.events} />
    </div>
  </Fragment>
)


export const ServiceList = ({ service_registrations }) => {
  let { loading = false, data = [] } = service_registrations

  if (loading) return <Loading>Loading CCS Service Registrations</Loading>
  if (data.length === 0) return <Empty />

  return (
    <Fragment>
      <RecordDisplayList
        {...{
          records: data,
          name: 'CCS Service Registration',
          level1,
          level2,
          recordBase: 'gov_record',
          showRaw: true,
          recordBadgesComponent: RegoBadges,
          actionButtonsComponent: recordActionsToDisplay({
            actionsForRecord,
          }),
        }}
      />
    </Fragment>
  )
}

export default ServiceList



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/views/index.js